import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import {Container} from './styles';
import Contrato from '../../assets/emojis/ajuda/contrato.png';



import { toast, Slide, ToastContainer } from 'react-toastify';
import '../../css/ReactToastify.css';
import { IoMdCloseCircle, IoMdCheckmarkCircle } from 'react-icons/io'

export default class Meucontrato extends Component {
    constructor(props) {
        super(props);
        this.state = {
            superUser: false,
            permission: null,
            showButton: false,
            carregou: true,
            token: null,
            saved: false
        }
    }


    render() {
        return(
            this.state.superUser && this.state.permission === 0 ? (
                <Container>
                    <h1 style={{
                        fontFamily: 'Montserrat',
                        fontSize: 18,
                        fontWeight: 600
                    }}>Você não possui permissão para visualizar esta página.</h1>
                </Container>
            ) : (
            <Container>
                <ToastContainer limit={1} />
            
            {this.state.carregou ?
            <div className="div-pai">
                <div className="div-rota">

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/'}>
                    <span
                        className="rotas" >
                        Início
                    </span>
                </Link>
                
                <span className="rotas"> {'>'} </span>
                
                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/ajuda'}>
                    <span
                        className="rotas">
                        Ajuda
                    </span>
                </Link>

                <span className="rotas"> {'>'} </span>

                <Link 
                    style={{ textDecoration: 'none' }}
                    to={'/meucontrato'}>
                    <span>
                        Meu contrato
                    </span>
                </Link>

                </div>

                <img alt="" className="emoji" src={Contrato} />

                <h1>Meu contrato</h1>

                <h5>Obtenha informações sobre taxas e condições ofertadas</h5>

                <hr/>

                <div className="div-app">
                    <h2>Tipo de contrato</h2>
                        {/* <h4>Crédito</h4> */}

                        <label for="pessoaJuridica" class="disabled">Pessoa Jurídica</label>

                    <div className='div-input'>
                        <input
                                // value=
                                name="valor"
                                type="text"
                                required
                                style={{
                                    caretColor: 'transparent'
                                }}
                        />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Data do contrato</span>
                            </label>
                    </div>    

                    <div className='div-input'>
                        <input
                                // value=
                                name="valor"
                                type="text"
                                required
                                style={{
                                    caretColor: 'transparent'
                                }}
                        />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">CNPJ</span>
                            </label>
                    </div>

                    <div className='div-input'>
                        <input
                                // value=
                                name="valor"
                                type="text"
                                required
                                style={{
                                    caretColor: 'transparent'
                                }}
                        />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Comissão</span>
                            </label>
                    </div>

                    <div className='div-input'>
                        <input
                                // value=
                                name="valor"
                                type="text"
                                required
                                style={{
                                    caretColor: 'transparent'
                                }}
                        />
                            <label htmlFor="" className="label-name">
                                <span className="content-name">Mensalidade</span>
                            </label>
                    </div>

                    <h4>Contrato de prestação de serviço</h4>

                    <div className="botao">
                        <button

                        //ver******************
                        onClick={() => this.salvar()} 
                            className="salvar">
                                Visualizar contrato
                        </button>
                    </div>

                    <a href="https://www.exemplo.com" class="link">Solicitar resolução do contrato</a>      
                </div>
            </div>

            : null}

            </Container> )
        )
    }
}
